import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {SWRConfig} from "swr";
import SuspenseContent from "./containers/SuspenseContent";
import axios from "axios";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <SWRConfig
        value={{
            fetcher: (data) => {
                let url, args = {};
                if (typeof data === 'string') {
                    url = data;
                } else {
                    url = data.url;
                    args = data.args;
                }
                const dataList = [];
                for (const key in args) {
                    dataList.push(`${key}=${args[key]}`);
                }
                url = dataList.length > 0 ? `${url}?${dataList.join('&')}` : url;
                return axios.get(url).then((res) => res.data)
            },
            provider: () => new Map(),
            //필요하면 true
            suspense: false,
            isOnline() {
                /* 네트워크 상태 감지자 커스터마이징 */
                return true
            },
            isVisible() {
                /* visibility 상태 감지자 커스터마이징 */
                return true
            },
            initFocus(callback) {
                /* 상태 공급자에 리스너 등록 */
            },
            initReconnect(callback) {
                /* 상태 공급자에 리스터 등록 */
            }
        }}
    >
        <Suspense fallback={<SuspenseContent/>}>

            {/*<PersistGate loading={null} persistor={persistor}>*/}
            <App/>
        </Suspense>
        {/*</PersistGate>*/}
    </SWRConfig>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
